import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import ContactDataTable from '../../components/ManageContact/ManageContact';
import "../../components/CommunicationTemplete/CommunicationTemplate.css";

const defaultTheme = createTheme();

const ManageContact = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="ctpl-page-header">
        <div className="ctpl-title-col">
          <h1>Manage Contacts</h1>
          <p>Add and manage the recipients who receive WhatsApp &amp; email alerts.</p>
        </div>
      </div>

      <ContactDataTable />
    </ThemeProvider>
  );
};

export default ManageContact;